import * as React from 'react';
import styled from 'styled-components';
import {
  correctShowingTypeLabel,
  formatPhoneNumber,
  featureEnabled,
} from 'utils';
import { AppointmentType } from '@bb/domain/dist/types';
import { isEmpty } from 'lodash';
import CustomContactButtons from './CustomContactButtons';

interface CustomContactProps {
  nonAgent: any;
  customContact: any;
  naTypeMap: any;
  appointment: any;
  selectSearchRoster: any;
  bookFor: any;
  customContactEdit: any;
  deleteCustomAgentOrContact: any;
  isSubmitting: any;
  updateState: any;
  customAgent: any;
  auth: any;
  preApproved: boolean;
  appointmentTypes: AppointmentType[];
}

const Step1IntCustomContact: React.FC<CustomContactProps> = ({
  nonAgent,
  customContact,
  naTypeMap,
  appointment,
  selectSearchRoster,
  bookFor,
  customContactEdit,
  deleteCustomAgentOrContact,
  updateState,
  customAgent,
  auth,
  preApproved,
  appointmentTypes,
}) => {
  const hideCustomAgentEdit =
    (bookFor === 'others' &&
      !isEmpty(customAgent) &&
      customAgent.createdBy !== auth._id) ||
    (!isEmpty(nonAgent) && nonAgent.orgId !== auth.org.id);

  const buildNonAgentWarning = () => {
    let warning = (
      <StyledNotice>
        Listing agent to confirm approval for this contact
      </StyledNotice>
    );

    const deprecatedWarning = (
      <div>Must deliver confirmation by phone to their office</div>
    );

    if (!featureEnabled('nonAgentNotificationFeature')) {
      warning = deprecatedWarning;
      return warning;
    }

    if (featureEnabled('preapproveAutomatedCustomContacts') && preApproved) {
      if (preApproved) return null;
    }

    return warning;
  };

  return (
    <div>
      <div>
        <label>Name: </label>{' '}
        <span>
          {customContact.firstName.toUpperCase()}{' '}
          {customContact.lastName.toUpperCase()}, {naTypeMap[appointment.type]}
        </span>
      </div>
      {customContact.org && (
        <>
          {customContact.org.name && (
            <div>
              <h5>{customContact.org.name.toUpperCase()}</h5>
            </div>
          )}
          <div className="m-b-sm">
            {customContact.org.address &&
              customContact.org.address.toUpperCase()}
          </div>
          <div>
            <label>Office: </label>
            <span>{formatPhoneNumber(customContact.org.phone)}</span>
          </div>
        </>
      )}
      <div>
        <label>Mobile: </label>
        <span>{formatPhoneNumber(customContact.phone)}</span>
      </div>
      <div>
        <label>Email: </label> <span>{customContact.email}</span>
      </div>
      {customContact.isNotAgent && (
        <div className="important m-b-sm m-t-sm">
          This person is NOT an agent
        </div>
      )}
      {buildNonAgentWarning()}

      {bookFor !== 'nonAgent' && (
        <div className="form-group">
          <label>Showing Type</label>
          <select
            value={appointment.type}
            onChange={e => {
              const newType = e.target.value;
              updateState((draft: any) => {
                draft.appointment.type = newType;
              });
            }}
            className="form-control"
            data-cy="showing-type"
          >
            {appointmentTypes &&
              appointmentTypes.map(at => (
                <option key={at} value={at}>
                  {correctShowingTypeLabel(at)}
                </option>
              ))}
          </select>
        </div>
      )}

      <CustomContactButtons
        isMlsCustomContact={Boolean(nonAgent.onboardingPortalId)}
        customContactSaved
        updateState={updateState}
        bookFor={bookFor}
        customContactEdit={customContactEdit}
        deleteCustomAgentOrContact={deleteCustomAgentOrContact}
        selectSearchRoster={selectSearchRoster}
        appointment={appointment}
        hideCustomAgentEdit={hideCustomAgentEdit}
      />
    </div>
  );
};

const StyledNotice = styled.p`
  margin-bottom: 16px;
`;

export default Step1IntCustomContact;
